import type { FC } from 'react';

import ExoticsMarketBandContent from './exotics-market-band-content';
import type { ExoticsMarketBandProps } from './types';

const ExoticsMarketBandWidget: FC<ExoticsMarketBandProps> = ({ instrumentId }) => (
  <ExoticsMarketBandContent instrumentId={instrumentId} />
);

export default ExoticsMarketBandWidget;
